export default __webpack_public_path__ + "static/media/product-cycle.9d669ac1.svg";